import { memo, useMemo, useRef } from 'react';
import classNames from 'classnames/bind';
import { ExportVersionFile } from 'common/types';
import { PlayerBarActionMode, defaultStyle } from './PlayerBar';

import styles from './index.module.css';

const cx = classNames.bind(styles);

const calculateMarkLeft = ({ tickWidth, markMiddleWidth, frameIndex, mode }) => {
  let markLeft = (frameIndex - 1) * tickWidth + tickWidth / 2 - markMiddleWidth / 2; // 向右偏移半格,减去中线半宽，居中对齐
  if (mode === 'review') {
    markLeft -= tickWidth / 2;
  }

  return markLeft;
};

const markHoverStyle = ({ tickWidth, frameIndex, mode }) => {
  const left = calculateMarkLeft({ frameIndex, mode, tickWidth, markMiddleWidth: defaultStyle.markMiddleWidth });
  const width = tickWidth < defaultStyle.markMiddleWidth ? defaultStyle.markMiddleWidth : tickWidth;

  return {
    width: `${width}px`,
    left: `${left}px`,
    opacity: 1,
  };
};

const PlayListMark = ({
  playList,
  curTakeIndex,
  tickWidth,
}: {
  playList: ExportVersionFile[];
  curTakeIndex: number;
  tickWidth: number;
}) => {
  const markRef = useRef<any>(null);
  let offset = 0;
  const list = useMemo(() => {
    return playList.map((playItem: ExportVersionFile) => {
      const item = {
        ...playItem,
        offset: offset,
      };
      const totalFrames = playItem.rules.find(rule => rule.ruleType === 'TotalFrames')?.checkResult as number;
      offset += totalFrames;
      return item;
    });
  }, [playList]);

  return (
    <>
      {list.map((playItem, index) => {
        if (index === 0) return null;
        return (
          <div
            className={cx('mark', 'mark-hover', 'mark-hover--review', 'mark-file-list')}
            ref={markRef}
            style={markHoverStyle({
              frameIndex: Math.round(playItem.offset),
              mode: PlayerBarActionMode.Review,
              tickWidth: tickWidth,
            })}>
            <div className={cx('mark-middle')} />
          </div>
        );
      })}
    </>
  );
};
export default memo(PlayListMark);
